import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Loader from "@/components/Loader";
import { ThemeProvider } from "@/lib/theme-provider";
import { GSAPProvider } from "@/lib/gsap-context";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <ThemeProvider>
      <GSAPProvider>
        <div className="App">
          {loading && <Loader />}
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="light" position="top-center" richColors />
        </div>
      </GSAPProvider>
    </ThemeProvider>
  );
}

export default App;
